// extracted by mini-css-extract-plugin
export var featured = "style-module--featured--9390e";
export var links = "style-module--links--cfeb5";
export var menu = "style-module--menu--93e2c";
export var menuCta = "style-module--menuCta--e185b";